import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import './LabelTagDisplay.scss';

function convertToProjectTagIds(str) {
	return str.split(',').map((num) => num.trim());
}

const LabelTagDisplay = ({ tags, tagIds }) => {
	if (tagIds === undefined) {
		return <Fragment></Fragment>;
	}

	const result = convertToProjectTagIds(tagIds);

	// Convert tagIds to unique integers
	const uniqueTagIds = [...new Set(result.map(Number))];

	// Filter and map the tags based on uniqueTagIds
	const displayTags = uniqueTagIds.map((id) => tags.find((tag) => tag.id === id)).filter((tag) => tag !== undefined);

	return (
		<div className='label-container'>
			{displayTags.length > 3 ? (
				<div className='label-row full-width'>
					{displayTags.map((tag) => (
						<div
							key={tag.id}
							className='label'
							style={{
								backgroundColor: tag.styles.backgroundColor,
								color: tag.styles.color,
							}}
						>
							{tag.name}
						</div>
					))}
				</div>
			) : (
				<div className='label-row'>
					{displayTags.map((tag) => (
						<div
							key={tag.id}
							className='label'
							style={{
								backgroundColor: tag.styles.backgroundColor,
								color: tag.styles.color,
							}}
						>
							{tag.name}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

LabelTagDisplay.propTypes = {
	tags: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired,
		styles: PropTypes.shape({
			backgroundColor: PropTypes.string,
			color: PropTypes.string
		})
	})).isRequired,
	tagIds: PropTypes.string,
};

export default LabelTagDisplay;
